var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectionSlash = function SvgIconSelectionSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24 3.077a1 1 0 0 0-1.48 1.346l15 16.5a1 1 0 1 0 1.48-1.346zM9.5 3.75a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M9.5 20.25a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1M17.25 2.75a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V4.5a1.75 1.75 0 0 0-1.75-1.75zM20.25 9.5a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M4.75 10.5a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0zM3.75 16.25a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2H4.5a1.75 1.75 0 0 1-1.75-1.75v-2.25a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconSelectionSlash;